/*
 * @Description:
 */
import { Language, InvoiceType, ValueType, MaterialType, prePrinting } from '@/constant/options'
export default {
  ...Language.zhCn,
  ...InvoiceType.zhCn,
  ...ValueType.zhCn,
  ...MaterialType.zhCn,
  ...prePrinting.en,
  common: {
    serialNumber: '编号',
    qty: '数量',
    search: '检索',
    reset: '重置',
    submit: '提交',
    delete: '删除',
    edit: '编辑',
    examine: '查看',
    operate: '操作',
    updateSuccess: '更新成功！',
    createSuccess: '创建成功！',
    deleteTip: '此操作将删除此条记录, 是否继续?',
    deleteSuccess: '删除成功！',
    addSuccess: '添加成功！',
    cancelDelete: '已取消删除！',
    create: '创建',
    isActive: '是否可用',
    active: '可用',
    notActive: '不可用',
    isRequired: '是必需的',
    createTime: '创建时间',
    updateTime: '更新时间',
    minNumber: '最小值为: ',
    add: '添加',
    end: '结束',
    next: '下一步',
    value: '值',
    finish: '完成',
    inputSearch: '请输入搜索信息并Enter!',
    baseInfo: '基本信息',
    needQuantity: '所需数量',
    save: '保存',
    yes: '是',
    no: '否',
    downloadTip: '点击文件名下载',
    noData: '暂无数据',
    none: '无',
    cancel: '取消',
    tags: '标签',
    addTags: '添加标签',
    noFatherCategoryId: '父级模板类别ID不存在！',
    uploading: '上传中'
  },
  route: {
    dashboard: '首页',
    product: '打印产品',
    printerMagage: '打印机管理',
    materialMagage: '耗材管理',
    appMagage: 'APP管理',
    appResourceMagage: 'APP资源管理',
    appUserMagage: 'APP用户管理',
    templateMagage: '模板管理',
    templatePreset: '预置模板列表',
    templateCategoryUser: '用户模板分类',
    shoppingInvoice: '用户发票抬头',
    shoppingAddress: '用户收货地址',
    printerMaterials: '打印机耗材',
    paperTextureDef: '耗材纸带材质',
    paperColorDef: '耗材纸带颜色',
    materialAttributeValue: '耗材扩展属性',
    materialAttributeDef: '耗材属性定义',
    material: '耗材',
    labelIconCategory: '标签图标分类',
    labelIcon: '标签图标列表',
    labelHistory: '标签打印记录',
    labelFrameCategory: '标签边框分类',
    labelFrame: '标签边框列表',
    industryAndCategoryLanguage: '模板类别多语言',
    industryAndCategory: '预置模板类别',
    customerMaterials: '用户定制耗材',
    customer: '客户',
    applicationVersion: 'APP版本管理',
    applicationPrinters: 'APP中的打印机',
    application: 'APP列表',
    printer: '打印机',
    printerCategory: '打印机类别',
    templateUser: '用户模板列表',
    tags: '检索Tag',
    ribbonColorDef: '耗材色带颜色定义',
    materialCategory: '耗材类别',
    materialCategoryLanguage: '耗材类别多语言',
    fonts: '字体',
    userList: '用户列表',
    labelFrameCategoryLanguage: '边框分类多语言',
    labelIconCategoryLanguage: '图标分类多语言',
    materialType: '耗材标签类型',
    materialCategoryUser: '用户自定义耗材分类'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    theme: '换肤',
    size: '布局大小',
    profile: '个人中心'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    bathDelete: '批量删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  message: {
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  errorMsg: {
    notFound: '没有找到',
    checkError: '校验失败',
    checkEmptyError: '不能为空',
    checkExistError: '已存在',
    canNotDelete: '无法删除',
    dataNotMatch: '数据不匹配',
    internalError: '内部错误'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    showTagsView: '显示 Tags-View',
    showSidebarLogo: '显示侧边栏 Logo',
    fixedHeader: '固定 Header',
    sidebarTextTheme: '侧边栏文字主题色'
  },
  templatePreset: {
    templateName: '模板名称',
    presetCategoryId: '模板所属类别',
    labelThumbnail: '标签缩略图',
    labelContent: '标签内容',
    labelWidth: '可打印长度',
    labelLength: '可打印宽度',
    targetLanguage: '目标语言',
    templateNameP: '请输入模板名称',
    presetCategoryIdP: '请选择模板所属类别',
    labelThumbnailP: '请输入标签缩略图',
    labelContentP: '请输入标签内容',
    labelWidthP: '请输入可打印长度',
    labelLengthP: '请输入可打印宽度',
    targetLanguageP: '请选择目标语言',
    create: '新建模板',
    edit: '编辑模板',
    editThumbnail: '编辑模板缩略图',
    materialType: '标签类型',
    materialTypeP: '请选择标签类型'
  },
  templateCategoryUser: {
    categoryName: '模板类别名称',
    userId: '用户ID',
    displayOrder: '显示顺序',
    categoryNameP: '请输入模板类别名称',
    userIdP: '请输入用户ID',
    displayOrderP: '请输入显示顺序',
    create: '新建模板类别',
    edit: '编辑模板类别',
    clientId: 'APP本地ID',
    clientIdP: '请输入APP本地ID'
  },
  shoppingInvoice: {
    userName: '用户名',
    invoiceTitle: '发票抬头',
    taxNumber: '单位税号',
    registeredAddress: '注册地址',
    registeredPhone: '注册电话',
    bankName: '开户银行名称',
    bankAccount: '开户银行账号',
    invoiceType: '发票类型',
    userNameP: '请输入用户名',
    invoiceTitleP: '请输入发票抬头',
    taxNumberP: '请输入单位税号',
    registeredAddressP: '请输入注册地址',
    registeredPhoneP: '请输入注册电话',
    bankNameP: '请输入开户银行名称',
    bankAccountP: '请输入开户银行账号',
    invoiceTypeP: '请选择发票类型',
    create: '新建用户发票抬头',
    edit: '编辑用户发票抬头'
  },
  shoppingAddress: {
    userName: '用户名',
    customerName: '收货人名称',
    telephone: '收货人电话号码',
    addressSheng: '省',
    addressShi: '市',
    addressXian: '县区',
    addressStreet: '街道',
    addressDetails: '门牌号',
    userNameP: '请输入用户名',
    customerNameP: '请输入收货人名称',
    telephoneP: '请输入收货人电话号码',
    addressShengP: '请输入省',
    addressShiP: '请输入市',
    addressXianP: '请输入县区',
    addressStreetP: '请输入街道',
    addressDetailsP: '请输入门牌号',
    create: '新建用户收货地址',
    edit: '编辑用户收货地址'
  },
  printerMaterials: {
    materialId: '耗材ID',
    materialName: '耗材名称',
    printerId: '打印机ID',
    printerName: '打印机名称',
    materialIdP: '请输入耗材ID',
    materialNameP: '请输入耗材名称',
    printerIdP: '请输入打印机ID',
    printerNameP: '请输入打印机名称',
    create: '新建打印机耗材',
    edit: '编辑打印机耗材'
  },
  paperTextureDef: {
    textureComment: '材质说明',
    textureCommentP: '请输入材质说明',
    create: '添加新耗材材质',
    edit: '编辑耗材材质'
  },
  paperColorDef: {
    colorComment: '颜色说明',
    colorCommentP: '请输入颜色说明',
    colorValueR: '颜色R值',
    colorValueG: '颜色G值',
    colorValueB: '颜色B值',
    colorValueRP: '请输入颜色R值',
    colorValueGP: '请输入颜色G值',
    colorValueBP: '请输入颜色B值',
    create: '添加新耗材颜色',
    edit: '编辑耗材颜色'
  },
  materialAttributeValue: {
    materialId: '耗材ID',
    attributeId: '耗材属性定义表id',
    value: '属性值',
    materialIdP: '请输入耗材ID',
    attributeIdP: '请输入耗材属性定义表id',
    valueP: '请输入属性值',
    create: '新建耗材属性',
    edit: '编辑耗材属性'
  },
  materialAttributeDef: {
    name: '耗材属性名称',
    valueType: '属性值类型',
    nameP: '请输入耗材属性名称',
    valueTypeP: '请选择属性值类型',
    create: '新建耗材属性定义',
    edit: '编辑耗材属性定义'
  },
  material: {
    materialModel: '标准品型号',
    materialName: '成品料号',
    materialType: '标签类型',
    labelWidth: '标签纸高度',
    labelLength: '标签纸长度',
    usableWidth: '可打印高度',
    usableLength: '可打印长度',
    ribbonColor: '色带颜色',
    paperColor: '标识底色 (配色)',
    paperTexture: '耗材材质',
    labelPreviewImage: '标签缩略图',
    labelCapacity: '实际容量',
    encapsulationType: '标签封装形式',
    targetIndustry: '标签应用行业',
    materialCategory: '耗材分类',
    materialModelP: '请输入标准品型号',
    materialNameP: '请输入成品料号',
    materialTypeP: '请选择标签类型',
    labelWidthP: '请输入标签纸高度',
    labelLengthP: '请输入标签纸长度',
    usableWidthP: '请输入可打印高度',
    usableLengthP: '请输入可打印长度',
    ribbonColorP: '请输入色带颜色',
    paperColorP: '请输入标识底色 (配色)',
    paperTextureP: '请输入耗材材质',
    labelPreviewImageP: '请输入标签缩略图',
    labelCapacityP: '请输入实际容量',
    encapsulationTypeP: '请输入标签封装形式',
    targetIndustryP: '请输入标签应用行业',
    materialCategoryP: '请输入耗材分类',
    create: '新建耗材',
    edit: '编辑耗材',
    labelBackgroundImage: '标签预印背景图',
    rawMaterialNumber: '原材料号',
    texture: '纹理',
    prePrinting: '是否预印',
    specialSize: '特别尺寸',
    capacityUnit: '容量单位',
    layoutColumns: '排版列数',
    barcodeRibbon: '匹配碳带',
    rawMaterialNumberP: '请输入原材料号',
    textureP: '请输入纹理',
    prePrintingP: '请输入是否预印',
    specialSizeP: '请输入特别尺寸',
    capacityUnitP: '请输入容量单位',
    layoutColumnsP: '请输入排版列数',
    barcodeRibbonP: '请输入匹配碳带'
  },
  labelIconCategory: {
    categoryName: 'ICON类别显示名称',
    categoryNameP: '请输入ICON类别显示名称',
    create: '新建标签图标分类',
    edit: '编辑标签图标分类',
    categoryOrder: 'ICON分类排序编号',
    categoryOrderP: '请输入ICON分类排序编号',
    updateOrder: '编辑排序'
  },
  labelIcon: {
    imageUrl: '图标文件地址',
    iconThumbnail: '图标预览',
    categoryId: '图标所属类别',
    imageUrlP: '请输入图标文件地址',
    iconThumbnailP: '请添加图标预览',
    categoryIdP: '请选择图标所属类别',
    create: '新建标签图标',
    edit: '编辑标签图标'
  },
  labelHistory: {
    userName: '用户名',
    materialName: '耗材名称',
    materialType: '标签类型',
    labelWidth: '耗材标签纸宽度',
    labelLength: '耗材标签纸长度',
    labelThumbnail: '标签的缩略图',
    labelContent: '标签内容',
    userNameP: '请输入用户名',
    materialNameP: '请输入耗材名称',
    materialTypeP: '请选择标签类型',
    labelWidthP: '请输入耗材标签纸宽度',
    labelLengthP: '请输入耗材标签纸长度',
    labelThumbnailP: '请添加标签的缩略图',
    labelContentP: '请输入标签内容',
    create: '新建标签打印记录',
    edit: '编辑标签打印记录',
    labelName: '模板名称',
    labelNameP: '请输入模板名称',
    isFixedLength: '连续标签是否定长',
    isFixedLengthP: '请输入连续标签是否定长'
  },
  labelFrameCategory: {
    categoryName: '边框类别显示名称',
    categoryOrder: '边框分类排序编号',
    order: '标签分类编号',
    categoryNameP: '请输入边框类别显示名称',
    categoryOrderP: '请输入边框分类排序编号',
    orderP: '请输入标签分类编号',
    create: '新建标签边框分类',
    edit: '编辑标签边框分类',
    updateOrder: '编辑排序'
  },
  labelFrame: {
    leftImageUrl: '边框左侧图片',
    rightImageUrl: '边框右侧图片',
    frameThumbnail: '边框预览图',
    categoryId: '边框类别',
    leftImageUrlP: '请输入边框左侧图片',
    rightImageUrlP: '请输入边框右侧图片',
    frameThumbnailP: '请添加边框预览图',
    categoryIdP: '请输入边框类别',
    create: '新建标签边框',
    edit: '编辑标签边框'
  },
  industryAndCategoryLanguage: {
    categoryId: '行业分类的ID',
    category: '行业分类',
    zhCn: '中文简体',
    zhTw: '中文繁体',
    en: '英语',
    ja: '日语',
    ko: '韩语',
    de: '德语',
    fr: '法语',
    it: '意大利语',
    es: '西班牙语',
    ar: '阿拉伯语',
    ru: '俄语',
    nl: '荷兰语',
    pt: '葡萄牙语',
    pl: '波兰语',
    th: '泰语',
    cs: '捷克语',
    sk: '斯洛伐克语',
    el: '希腊语',
    hu: '匈牙利语',
    bg: '保加利亚语',
    tr: '土耳其语',
    ro: '罗马尼亚语',
    categoryIdP: '请输入行业分类的ID',
    categoryP: '请输入行业分类',
    zhCnP: '请输入中文简体文言',
    zhTwP: '请输入中文繁体文言',
    enP: '请输入英语文言',
    jaP: '请输入日语文言',
    koP: '请输入韩语文言',
    deP: '请输入德语文言',
    frP: '请输入法语文言',
    itP: '请输入意大利语文言',
    esP: '请输入西班牙语文言',
    arP: '请输入阿拉伯语文言',
    ruP: '请输入俄语文言',
    nlP: '请输入荷兰语文言',
    ptP: '请输入葡萄牙语文言',
    plP: '请输入波兰语文言',
    thP: '请输入泰语文言',
    csP: '请输入捷克语文言',
    skP: '请输入斯洛伐克语文言',
    elP: '请输入希腊语文言',
    huP: '请输入匈牙利语文言',
    bgP: '请输入保加利亚语文言',
    trP: '请输入土耳其语文言',
    roP: '请输入罗马尼亚语文言',
    create: '添加行业类别多语言',
    edit: '编辑行业类别多语言'
  },
  industryAndCategory: {
    categoryId: '模板类别ID',
    categoryName: '模板类别名称',
    fatherCategoryId: '父级模板类别ID',
    categoryNameP: '请输入模板类别名称',
    fatherCategoryIdP: '请输入父级模板类别ID',
    create: '新建目标行业/类别',
    edit: '编辑目标行业/类别'
  },
  customerMaterials: {
    materialId: '耗材ID',
    materialName: '耗材名称',
    customerId: '客户ID',
    customerName: '客户名称',
    materialIdP: '请输入耗材ID',
    materialNameP: '请输入耗材名称',
    customerIdP: '请输入客户ID',
    customerNameP: '请输入客户名称',
    create: '添加用户定制耗材',
    edit: '编辑用户定制耗材'
  },
  customer: {
    customerName: '客户名称',
    customerNameP: '请输入客户名称',
    create: '添加客户',
    edit: '编辑客户'
  },
  applicationVersion: {
    appId: 'APP ID',
    appName: 'APP名称',
    releaseVersion: '版本号',
    releaseDate: '发布日期',
    isAndroidApp: 'Android平台',
    thirdPartyStore: '第三方安卓市场',
    thirdPartyWebsite: '第三方Android Store安装包地址',
    appIdP: '请输入APP ID',
    appNameP: '请输入APP名称',
    releaseVersionP: '请输入版本号',
    releaseDateP: '请输入发布日期',
    isAndroidAppP: '请选择是否为Android平台',
    thirdPartyStoreP: '请输入第三方安卓市场',
    thirdPartyWebsiteP: '请输入第三方Android Store安装包地址',
    create: '新建APP版本',
    edit: '编辑APP版本',
    package: '上传APK',
    isAndroidAppTrue: '是',
    isAndroidAppFalse: '否'
  },
  applicationPrinters: {
    partnerNumber: '合作伙伴号码',
    printerId: '打印机ID',
    printerName: '打印机名称',
    appId: 'APP ID',
    appName: 'APP 名称',
    partnerNumberP: '请输入合作伙伴号码',
    printerIdP: '请输入打印机ID',
    printerNameP: '请输入打印机名称',
    appIdP: '请输入APP ID',
    appNameP: '请输入APP 名称',
    create: '新建关联关系',
    edit: '编辑关联关系'
  },
  application: {
    appName: 'APP名称',
    appDescription: 'APP描述',
    partnerNumber: 'PartnerNo.',
    minVersion: '最旧可用版本',
    currentVersion: 'APP 最新版本',
    packageAddress: 'APP 安装包地址',
    appNameP: '请输入APP名称',
    appDescriptionP: '请输入APP描述',
    partnerNumberP: '请输入PartnerNo.',
    minVersionP: '请输入最旧可用版本',
    currentVersionP: '请输入APP 最新版本',
    packageAddressP: '请输入APP 安装包地址',
    create: '新建APP',
    edit: '编辑APP信息',
    createTip: '是否添加应用发布版本'
  },
  printer: {
    printerName: '打印机名称',
    isSupportUsb: '支持USB连接',
    isSupportBle: '支持BLE连接',
    isSupportWifi: '支持Wi-Fi连接',
    dpi: '打印机分辨率DPI',
    printHeadWidth: '打印头宽度',
    printerNameP: '请输入打印机名称',
    isSupportUsbP: '请选择是否支持USB方式连接',
    isSupportBleP: '请选择是否支持BLE方式连接',
    isSupportWifiP: '请选择是否支持Wi-Fi方式连接',
    dpiP: '请输入打印机分辨率DPI',
    printHeadWidthP: '请输入打印机打印头宽度，单位为毫米',
    create: '新建打印机信息',
    edit: '编辑打印机信息',
    isSupportUsbTrue: '是',
    isSupportBleTrue: '是',
    isSupportWifiTrue: '是',
    isSupportUsbFalse: '否',
    isSupportBleFalse: '否',
    isSupportWifiFalse: '否'
  },
  printerCategory: {
    categoryName: '打印机类别名称',
    categoryNameP: '请输入打印机类别名称',
    create: '新建打印机类别',
    edit: '编辑打印机类别'
  },
  fileUpload: {
    upload: '上传'
  },
  templateUser: {
    templateName: '模板名称',
    templateNameP: '请输入模板名称',
    userCategoryId: '模板所属的类别',
    userCategoryIdP: '请选择模板所属的类别',
    labelThumbnail: '标签缩略图',
    labelThumbnailP: '请选择标签缩略图',
    labelContent: '标签内容',
    labelContentP: '请输入标签内容',
    labelWidth: '可打印长度',
    labelWidthP: '请输入可打印长度',
    labelLength: '可打印宽度',
    labelLengthP: '请输入可打印宽度',
    edit: '编辑用户自定义标签模板',
    create: '新建用户自定义标签模板',
    userId: '用户ID',
    userIdP: '请输入用户ID',
    clientId: 'APP本地ID',
    clientIdP: '请输入APP本地ID',
    materialType: '标签类型',
    materialTypeP: '请选择标签类型'
  },
  tags: {
    tagValue: '标签名',
    tagValueP: '请输入标签名',
    edit: '编辑标签',
    create: '新建标签'
  },
  ribbonColorDef: {
    colorComment: '颜色说明',
    colorCommentP: '请输入颜色说明',
    edit: '编辑耗材色带颜色定义',
    create: '新建耗材色带颜色定义'
  },
  materialCategoryLanguage: {
    categoryId: '耗材类别的ID',
    category: '耗材类别',
    zhCn: '中文简体',
    zhTw: '中文繁体',
    en: '英语',
    ja: '日语',
    ko: '韩语',
    de: '德语',
    fr: '法语',
    it: '意大利语',
    es: '西班牙语',
    ar: '阿拉伯语',
    ru: '俄语',
    nl: '荷兰语',
    pt: '葡萄牙语',
    pl: '波兰语',
    th: '泰语',
    cs: '捷克语',
    sk: '斯洛伐克语',
    el: '希腊语',
    hu: '匈牙利语',
    bg: '保加利亚语',
    tr: '土耳其语',
    ro: '罗马尼亚语',
    categoryIdP: '请输入耗材类别的ID',
    categoryP: '请输入耗材类别',
    zhCnP: '请输入中文简体文言',
    zhTwP: '请输入中文繁体文言',
    enP: '请输入英语文言',
    jaP: '请输入日语文言',
    koP: '请输入韩语文言',
    deP: '请输入德语文言',
    frP: '请输入法语文言',
    itP: '请输入意大利语文言',
    esP: '请输入西班牙语文言',
    arP: '请输入阿拉伯语文言',
    ruP: '请输入俄语文言',
    nlP: '请输入荷兰语文言',
    ptP: '请输入葡萄牙语文言',
    plP: '请输入波兰语文言',
    thP: '请输入泰语文言',
    csP: '请输入捷克语文言',
    skP: '请输入斯洛伐克语文言',
    elP: '请输入希腊语文言',
    huP: '请输入匈牙利语文言',
    bgP: '请输入保加利亚语文言',
    trP: '请输入土耳其语文言',
    roP: '请输入罗马尼亚语文言',
    create: '添加行业类别多语言',
    edit: '编辑行业类别多语言'
  },
  materialCategory: {
    categoryId: '耗材类别ID',
    categoryName: '耗材类别名称',
    fatherCategoryId: '父级耗材类别ID',
    categoryNameP: '请输入耗材类别名称',
    fatherCategoryIdP: '请输入父级耗材类别ID',
    create: '新建耗材类别',
    edit: '编辑耗材类别'
  },
  fonts: {
    fontName: '字体名称',
    fontFileUrl: '字体文件',
    fontThumbnail: '字体样例缩略图',
    targetLanguage: '字体面向语言',
    fontNameP: '请输入字体名称',
    fontFileUrlP: '请添加字体文件',
    fontThumbnailP: '请添加字体样例缩略图',
    targetLanguageP: '请输入字体面向语言',
    create: '新建字体',
    edit: '编辑字体信息',
    editFont: '编辑字体文件',
    all: '所有语言',
    zhCn: '中文简体',
    zhTw: '中文繁体',
    en: '英语',
    ja: '日语',
    ko: '韩语',
    de: '德语',
    fr: '法语',
    it: '意大利语',
    es: '西班牙语',
    ar: '阿拉伯语',
    ru: '俄语',
    nl: '荷兰语',
    pt: '葡萄牙语',
    pl: '波兰语',
    th: '泰语',
    cs: '捷克语',
    sk: '斯洛伐克语',
    el: '希腊语',
    hu: '匈牙利语',
    bg: '保加利亚语',
    tr: '土耳其语',
    ro: '罗马尼亚语'
  },
  userList: {
    userId: '用户ID',
    userName: '用户名称',
    userNameP: '请输入用户名称',
    userType: '用户类型',
    nickName: '用户昵称',
    nickNameP: '请输入用户昵称',
    avatar: '用户头像',
    mobile: '用户电话',
    mobileP: '请输入用户电话',
    email: '用户邮箱',
    emailP: '请输入用户邮箱',
    edit: '编辑用户',
    userIdP: '请输入用户ID'
  },
  labelFrameCategoryLanguage: {
    categoryId: '边框分类的ID',
    category: '边框分类',
    zhCn: '中文简体',
    zhTw: '中文繁体',
    en: '英语',
    ja: '日语',
    ko: '韩语',
    de: '德语',
    fr: '法语',
    it: '意大利语',
    es: '西班牙语',
    ar: '阿拉伯语',
    ru: '俄语',
    nl: '荷兰语',
    pt: '葡萄牙语',
    pl: '波兰语',
    th: '泰语',
    cs: '捷克语',
    sk: '斯洛伐克语',
    el: '希腊语',
    hu: '匈牙利语',
    bg: '保加利亚语',
    tr: '土耳其语',
    ro: '罗马尼亚语',
    categoryIdP: '请输入边框分类的ID',
    categoryP: '请输入边框分类',
    zhCnP: '请输入中文简体文言',
    zhTwP: '请输入中文繁体文言',
    enP: '请输入英语文言',
    jaP: '请输入日语文言',
    koP: '请输入韩语文言',
    deP: '请输入德语文言',
    frP: '请输入法语文言',
    itP: '请输入意大利语文言',
    esP: '请输入西班牙语文言',
    arP: '请输入阿拉伯语文言',
    ruP: '请输入俄语文言',
    nlP: '请输入荷兰语文言',
    ptP: '请输入葡萄牙语文言',
    plP: '请输入波兰语文言',
    thP: '请输入泰语文言',
    csP: '请输入捷克语文言',
    skP: '请输入斯洛伐克语文言',
    elP: '请输入希腊语文言',
    huP: '请输入匈牙利语文言',
    bgP: '请输入保加利亚语文言',
    trP: '请输入土耳其语文言',
    roP: '请输入罗马尼亚语文言',
    create: '添加行业类别多语言',
    edit: '编辑行业类别多语言'
  },
  labelIconCategoryLanguage: {
    categoryId: '图标分类的ID',
    category: '图标分类',
    zhCn: '中文简体',
    zhTw: '中文繁体',
    en: '英语',
    ja: '日语',
    ko: '韩语',
    de: '德语',
    fr: '法语',
    it: '意大利语',
    es: '西班牙语',
    ar: '阿拉伯语',
    ru: '俄语',
    nl: '荷兰语',
    pt: '葡萄牙语',
    pl: '波兰语',
    th: '泰语',
    cs: '捷克语',
    sk: '斯洛伐克语',
    el: '希腊语',
    hu: '匈牙利语',
    bg: '保加利亚语',
    tr: '土耳其语',
    ro: '罗马尼亚语',
    categoryIdP: '请输入图标分类的ID',
    categoryP: '请输入图标分类',
    zhCnP: '请输入中文简体文言',
    zhTwP: '请输入中文繁体文言',
    enP: '请输入英语文言',
    jaP: '请输入日语文言',
    koP: '请输入韩语文言',
    deP: '请输入德语文言',
    frP: '请输入法语文言',
    itP: '请输入意大利语文言',
    esP: '请输入西班牙语文言',
    arP: '请输入阿拉伯语文言',
    ruP: '请输入俄语文言',
    nlP: '请输入荷兰语文言',
    ptP: '请输入葡萄牙语文言',
    plP: '请输入波兰语文言',
    thP: '请输入泰语文言',
    csP: '请输入捷克语文言',
    skP: '请输入斯洛伐克语文言',
    elP: '请输入希腊语文言',
    huP: '请输入匈牙利语文言',
    bgP: '请输入保加利亚语文言',
    trP: '请输入土耳其语文言',
    roP: '请输入罗马尼亚语文言',
    create: '添加行业类别多语言',
    edit: '编辑行业类别多语言'
  },
  materialType: {
    name: '耗材类型名称',
    baseType: '耗材基础类型',
    aUsable: 'A尺寸',
    bUsable: 'B尺寸',
    cUsable: 'C尺寸',
    dUsable: 'D尺寸',
    eUsable: 'E尺寸',
    fUsable: 'F尺寸',
    labelSizeImage: '标签尺寸示意图',
    nameP: '请输入耗材类型名称',
    baseTypeP: '请输入耗材基础类型',
    aUsableP: '请输入A尺寸',
    bUsableP: '请输入B尺寸',
    cUsableP: '请输入C尺寸',
    dUsableP: '请输入D尺寸',
    eUsableP: '请输入E尺寸',
    fUsableP: '请输入F尺寸',
    labelSizeImageP: '请输入标签尺寸示意图',
    create: '新建耗材标签类型',
    edit: '编辑耗材标签类型',
    editImg: '编辑标签尺寸示意图'
  },
  materialCategoryUser: {
    categoryName: '耗材类别名称',
    userId: '用户ID',
    displayOrder: '显示顺序',
    categoryNameP: '请输入耗材类别名称',
    userIdP: '请输入用户ID',
    displayOrderP: '请输入显示顺序',
    create: '新建耗材类别',
    edit: '编辑耗材类别',
    clientId: 'APP本地ID',
    clientIdP: '请输入APP本地ID'
  }
}
